export const modelicaKeywords = [
  'algorithm',
  'discrete',
  'false',
  'loop',
  'pure',
  'and',
  'each',
  'final',
  'model',
  'record',
  'annotation',
  'else',
  'flow',
  'not',
  'redeclare',
  'elseif',
  'for',
  'operator',
  'replaceable',
  'block',
  'elsewhen',
  'function',
  'or',
  'return',
  'break',
  'encapsulated',
  'if',
  'outer',
  'stream',
  'class',
  'end',
  'import',
  'output',
  'then',
  'connect',
  'enumeration',
  'impure',
  'package',
  'true',
  'connector',
  'equation',
  'in',
  'parameter',
  'type',
  'constant',
  'expandable',
  'initial',
  'partial',
  'when',
  'constrainedby',
  'extends',
  'inner',
  'protected',
  'while',
  'der',
  'external',
  'input',
  'public',
  'within',
];

export const rules = [
  {
    code: 'MIN_1_CHAR',
    desc: 'The name must be at least 1 character long.',
    isSatisfied: (str) => str.length > 0,
  },
  // {
  //   code: 'NO_DOT_ALLOWED',
  //   desc: 'No dot allowed in the name.',
  //   isSatisfied: (str) => str.indexOf('.') === -1,
  // },
  // {
  //   code: 'NO_SPACE_ALLOWED',
  //   desc: 'Space characters (space bar, tabulation, etc. ...) are not allowed in the name.',
  //   isSatisfied: (str) => str.match(/\s/) === null,
  // },
  {
    code: 'NUMBER_ONLY_NOT_ALLOWED',
    desc: 'Only Numbers is not allowed',
    isSatisfied: (str) => str.match(/^[0-9]+$/) === null,
  },
  // {
  //   code: 'ALPHA_NUMERIC_UNDERSCORE_ONLY',
  //   desc: 'Characters allowed are letters from A to Z, numbers, and underscore.',
  //   isSatisfied: (str) => str.match(/^[a-zA-Z0-9_]+$/) !== null,
  // },
  // {
  //   code: 'SPECIAL_CHAR_START',
  //   desc: 'Name can not start with special character or number.',
  //   isSatisfied: (str) => str.match(/^[a-zA-Z_]/) !== null,
  // },
  {
    code: 'RESTRICTED_MODELICA_KEYWORD',
    desc: 'Name cannot be a Modelica reserve keyword',
    isSatisfied: (str) => !modelicaKeywords.includes(str.toLowerCase()),
  },
  {
    code: 'NO_WORD_WORKSPACE',
    desc: "Name cannot be 'workspace'",
    isSatisfied: (str) => str.toLowerCase() !== 'workspace',
  },
];
